var $ = global.jQuery = global.$;
var mapConfig = require('../config').maps;
var InfoBubble = require('../third-party/infobubble');
var parser = require('../lib/parser');

var _Map = require('./_Map');

/**
 * Location details map with office InfoWindows
 * @class
 * @extends _Map
 */
var LocDetailsMap = _Map.extend(
  /** @lends LocDetailsMap.prototype */
  {
  /**
   * Runs when then map is loaded using the google map loader in the _Map base.
   * @param {object} google The google instance that is passed through by the google map loader in the _Map init() method
   */
  onMapLoaded: function(google) {
    var self = this;

    this.map.setOptions({
      maxZoom: 15
    });

    // Switch off map draggin on touch devices
    if (Modernizr.touchevents) {
      this.map.setOptions({
        draggable: false
      });
    }

    this.defaultIcon = {
      url: '/assets/images/map-pin.svg',
      scaledSize: new google.maps.Size(32, 50)
    };

    this.infoWindow = new InfoBubble({
      content: '',
      shadowStyle: 0,
      padding: 0,
      backgroundColor: 'rgb(255,255,255)',
      borderRadius: 0,
      arrowSize: 14,
      borderWidth: 0,
      hideCloseButton: true,
      maxWidth: 523,
      minHeight: 230
    });

    self.setupMarkers(google);

    $(window).on('resize orientationchange', function() {
      if (self.infoWindow.getMap()) {
        self.infoWindow.close();
        self.infoWindow.open();
      }
    });

  },
  /**
   * Set up the office markers
   * @param {object} google The google instance
   */
  setupMarkers: function(google) {
    var self = this;
    var markersData = this.$el.data('offices').items;
    var infoTmpl = require('templates/infoWindow.dot');
    var bounds = new google.maps.LatLngBounds();

    $.each(markersData, function(index) {
      var marker = self.createMarker(this.Latitude, this.Longitude);
      this.addressSplit = this.Address.split(',');

      marker.setMap(self.map);

      marker.html = infoTmpl(this);

      bounds.extend(marker.getPosition());

      if (markersData.length === 1) {
        setTimeout(function() {
          self.map.fitBounds(bounds);
          self.openInfoWindow(marker, google);
        }, 100);
      } else if (index === markersData.length - 1) {
        self.map.fitBounds(bounds);
      }

      google.maps.event.addListener(marker, 'click', function() {
        self.openInfoWindow(this, google);
      });

    });

    google.maps.event.addListener(self.map, 'resize', function() {
      self.map.fitBounds(bounds);
    });

  },
  /**
   * Open an infowindow at a particular marker
   * @param {object} marker The google maps marker you want to open
   * @param {object} google The google instance
   */
  openInfoWindow: function(marker, google) {
    var self = this;
    this.infoWindow.setContent(marker.html);
    this.infoWindow.open(this.map, marker);
    google.maps.event.addListener(this.infoWindow, 'domready', function() {
      parser.parse($(self.infoWindow.bubble_));
      $(self.infoWindow.bubble_).find('.info-window__close').on('click', function(event) {
        event.preventDefault();
        self.infoWindow.close();
        self.infoWindow.setMap(null);
        self.redraw();
      });
    });
  }
});

module.exports = LocDetailsMap;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/LocDetailsMap.js
// module id = 233
// module chunks = 0 1